import { BaseResponse } from "./base.response";

export type DeviceApprovalStatus = "pending" | "approved" | "denied" | "expired";

/**
 * TDE new-device approval request (GOOGLE_SSO_PLAN.md, Phase 3). `encryptedUserKey` and
 * `privateKey` are only present on the requester's own read of an approved request:
 * `encryptedUserKey` is the UserKey wrapped under the requesting device's public key, and
 * `privateKey` is the account's RSA private key (already encrypted under the UserKey).
 */
export class DeviceApprovalRequestResponse extends BaseResponse {
  id: string;
  status: DeviceApprovalStatus;
  publicKey: string;
  deviceName: string;
  requestIp: string;
  createdAt: string;
  expiresAt: string;
  encryptedUserKey: string;
  privateKey: string;

  constructor(response: any) {
    super(response);
    this.id = this.getResponseProperty("Id");
    this.status = this.getResponseProperty("Status");
    this.publicKey = this.getResponseProperty("PublicKey");
    this.deviceName = this.getResponseProperty("DeviceName");
    this.requestIp = this.getResponseProperty("RequestIp");
    this.createdAt = this.getResponseProperty("CreatedAt");
    this.expiresAt = this.getResponseProperty("ExpiresAt");
    this.encryptedUserKey = this.getResponseProperty("EncryptedUserKey");
    this.privateKey = this.getResponseProperty("PrivateKey");
  }
}
